export const questionsFour = [
  {
    id: 1,
    question:
      "Arrange the following words in a logical order : 1 - Travel, 2 - Destination, 3 - Payment, 4 - Seat number, 5 - Reservation, 6 - Availability of seat.",
    answer: "2,6,3,5,4,1",
    options: ["6,2,5,4,3,1", "5,3,4,1,6,2", "1,2,5,4,3,6", "2,6,3,5,4,1"],
    explanations: [
      "First, a destination is decided, secondly availability of seat is ascertained, followed by payment for the reservation. As a result, the berth is allotted and traveling is completed.",
    ],
  },
  {
    id: 2,
    question:
      "Arrange the following words in a logical order : 1 - Birth, 2 - Death, 3 - Funeral, 4 - Marriage, 5 - Education.",
    answer: "1,5,4,2,3",
    options: ["4,5,3,1,2", "1,5,4,2,3", "2,3,4,5,1", "1,3,4,5,2"],
    explanations: ["Birth > Education > Marraige > Death > Funeral"],
  },
  {
    id: 3,
    question: "Arrange marriage is sometimes better than love marriage",
    answer: "Probable",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "Metaphysical statements cannot be fully justified. Hence, Probable.",
    ],
  },
  {
    id: 4,
    question: "Mawsynram is the wettest place as it receives maximum rain fall",
    answer: "True",
    options: ["True", "False", "Probable", "Absurd"],
    explanations: [
      "Mawsynram is a town in the East Khasi Hills district of Meghalaya state which is the wettest place on Earth.",
    ],
  },
  {
    id: 5,
    question: "ab_ aa _ aaa _a_ ab_ a",
    answer: "abbaa",
    options: ["abbab ", "abaaa ", "aabba ", "abbaa"],
    explanations: ["The correct sequence is abaa/ abaa/ abaa/ abaa."],
  },
  {
    id: 6,
    question:
      "Lakshmi is elder than Meenu. Leela is elder than Meenu but younger than Lakshmi. Latha is younger than both Meenu and Hari but Hari is younger than Meenu. Who is the youngest?",
    answer: "Latha",
    options: ["Lakshmi", "Meenu", "Leela", "Latha"],
    explanations: [
      "According to the question, Lakshmi > Meenu,  Lakshmi > Leela > Meenu, Meenu > Hari > Latha, On arranging the above data, we get Lakshmi > Leela > Meenu > Hari > Latha. Hence, Latha is the youngest.",
    ],
  },
  {
    id: 7,
    question:
      "Sati is elder than Renu, Geeta is younger than Renu while Priya is elder than Sati. Who is the eldest?",
    answer: "Priya",
    options: ["Priya", "Sati", "Renu", "Geeta"],
    explanations: [
      "According to the question, Sati >Reenu, Reenu > Geeta, Priya > Sati. On arranging the above data, we get Priya > Sati > Reenu > Geeta. So, Priya is the eldest.",
    ],
  },
  {
    id: 8,
    question: "Gun : Bullet :: Chimney : ?",
    answer: "Smoke",
    options: ["Ground", "House", "Roof", "Smoke"],
    explanations: ["Second comes out of the first."],
  },
  {
    id: 9,
    question: "24.	Dog : Bark :: Goat : ?",
    answer: "Blent",
    options: ["Blent", "Howl", "Grunt", "Bray"],
    explanations: ["Second is the noise produced by the first."],
  },
  {
    id: 10,
    question: "Rupee: India :: Yen : ?",
    answer: "Japan",
    options: ["Turkey", "Bangladesh", "Pakistan", "Japan"],
    explanations: [
      "Rupee is the currency of India. Similarly, Yen is the currency of Japan.",
    ],
  },
  {
    id: 11,
    question: "A fish can breathe in water because",
    answer: "Fish have gills.",
    options: [
      "Fish don't have a nose.",
      "Fish don't need oxygen to live.",
      "Fish don't breath",
      "Fish have gills.",
    ],
    explanations: [
      "A fish breathes by taking water into its mouth and forcing it out through the gill passages.",
    ],
  },
  {
    id: 12,
    question: "'To save one’s face' means",
    answer: "To evade disgrace",
    options: [
      "To hide oneself",
      "To oppose",
      "To evade disgrace",
      "To say plainly",
    ],
    explanations: [
      "Example -  I was late to the meeting but tried to save face by blaming an urgent call.",
    ],
  },
  {
    id: 13,
    question: "SMELL is to NOSE, as SOUND is to:",
    answer: "Ear",
    options: ["Ear", "Eye", "Music", "None of these"],
    explanations: ["Smell is to Nose, as Sound is to Ear."],
  },
  {
    id: 14,
    question: "AIRCRAFT is to TRANSPORT as NEWSPAPER is to:",
    answer: "Media",
    options: ["Typing", "Publishing", "Editor", "Media"],
    explanations: [
      "Aircraft is to transport as the newspaper is to media. Reason: Aircraft is a medium of transport. Similarly, the newspaper is a type of media.",
    ],
  },
  {
    id: 15,
    question:
      "If FRIEND is coded as HUMJTK, how can CANDLE be written in that code? ",
    answer: "EDRIRL",
    options: ["DEQJQM", "DCQHQK", "EDRIRL", "ESJFME"],
    explanations: [
      "In the code, the first letter is the second alphabet, the second letter is the third alphabet, the third letter is the fourth alphabet, and so on after the corresponding letter in the word.",
    ],
  },
  {
    id: 16,
    question:
      "If FRAGRANCE is written as SBHSBODFG, how can IMPOSING be written?",
    answer: "NQPTJOHJ",
    options: ["NQPTJHOJ", "NQPTJOHJ", "NQTPJOHJ", "NQPTJOHI"],
    explanations: [
      "Each letter in the word is moved one step forward and the first letter of the group so obtained is put at the end, to obtain the code.",
    ],
  },
  {
    id: 17,
    question:
      "If ROBUST is coded as QNATRS in a certain language, which word would be coded as ZXCMP?",
    answer: "AYDNQ",
    options: ["AWDLQ", "AYDNQ", "BZEOR", "YYBNO"],
    explanations: [
      "Each letter of the word is one step ahead of the corresponding letter of the code.",
    ],
  },
  {
    id: 18,
    question:
      "If PALE is coded as 2134, EARTH is coded as 41590, how can is PEARL be coded in that language?",
    answer: "24153",
    options: ["25430", "29530", "25413", "24153"],
    explanations: [
      "The letters are coded accordingly P as 2, E as 4, A as 1, R as 5, and L as 3. So PEARL is coded as 24153.",
    ],
  },
  {
    id: 19,
    question:
      "If ROSE is coded as 6821, CHAIR is coded as 73456 and PREACH is coded as 961473, what will be the code for SEARCH?",
    answer: "214673",
    options: ["216473", "246173", "214673", "214763"],
    explanations: [
      "The letters are coded accordingly S as 2, E as 1, A as 4, R as 6, C as 7, and H as 3. i.e., 214673",
    ],
  },
  {
    id: 20,
    question:
      "If 'eraser' is called 'box', 'box' is called 'pencil', 'pencil' is called 'sharpener', and 'sharpener' is called 'bag', what will a child write with?",
    answer: "Sharpener",
    options: ["Eraser", "Bag", "Pencil", "Sharpener"],
    explanations: [
      "A child will write with a 'pencil', and a pencil is called a 'sharpener'. So, a child will write with a 'sharpener'.",
    ],
  },
  {
    id: 21,
    question: "Choose the word which is different from the rest.",
    answer: "Minister",
    options: ["King", "Queen", "Bishop", "Minister"],
    explanations: ["All except Minister are chessmen."],
  },
  {
    id: 22,
    question: "1, 3, 4, 8, 15, 27, ?",
    answer: "50",
    options: ["37", "44", "50", "55"],
    explanations: [
      "The sum of any three consecutive terms of the series gives the next term. So, missing number = 8 + 15 + 27 = 50.",
    ],
  },
  {
    id: 23,
    question: "1, 5, 13, 25, 41, ?",
    answer: "61",
    options: ["51", "57", "61", "63"],
    explanations: [
      "The pattern is + 4, + 8, + 12, + 16......So, missing term = 41 + 20 = 61.",
    ],
  },
  {
    id: 24,
    question: "1, 1, 2, 6, 24, ?, 720",
    answer: "120",
    options: ["100", "104", "108", "120"],
    explanations: [
      "The pattern is x 1, x 2, x 3, x 4,.....So, missing term = 24 x 5 = 120.",
    ],
  },
  {
    id: 25,
    question: "c _ bba _ cab _ ac _ ab _ ac",
    answer: "acbcb",
    options: ["abebe", "acbcb", "babec", "bcacb"],
    explanations: [
      "The series is cabbac/cabbac/cabbac. Thus, the pattern 'cabbac' is repeated.",
    ],
  },

  {
    id: 26,
    question: "Choose the word which is different from the rest.",
    answer: "Kangaroo",
    options: ["Kangaroo", "Orang-utang", "Gorilla", "Baboon"],
    explanations: ["All except Kangaroo are species of apes"],
  },
  {
    id: 27,
    question: "Choose the word which is different from the rest.",
    answer: "Retrieve",
    options: ["Censure", "Admonish", "Rebuke", "Retrieve"],
    explanations: ["All others are synonyms."],
  },
  {
    id: 28,
    question: "Choose the word which is different from the rest.",
    answer: "Enmity",
    options: ["Friendship", "Attachment", "Intimacy", "Enmity"],
    explanations: ["All except Enmity are synonyms."],
  },

  {
    id: 29,
    question:
      "Shyam walks 5 km towards East and then turns left and walks 6 km. Again he turns right and walks 9 km. Finally, he turns to his right and walks 6 km. How far is he from the starting point?",
    answer: "14 km",
    options: ["26 km", "21 km", "14 km", "9 km"],
    explanations: [
      "No answer description available for this question. We are working on adding a picture representation of the explanation.",
    ],
  },
  {
    id: 30,
    question: "Choose the word which is different from the rest.",
    answer: "Marx",
    options: ["Mahavir", "Buddha", "Marx", "Jesus"],
    explanations: ["All except Marx propagated non-violence."],
  },
  {
    id: 31,
    question:
      "Pointing to a man in a photograph, a woman said, 'His brother's father is the only son of my grandfather.' How is the woman related to the man in the photograph? ",
    answer: "Sister",
    options: ["Sister", "Aunt", "Grandmother", "Daughter"],
    explanations: [
      "Only son of woman’s grandfather – Woman’s father; Man’s brother father – Man’s father. So, the woman is the man’s sister.",
    ],
  },
  {
    id: 32,
    question:
      "A told B,' The girl I met yesterday was the youngest daughter of the brother–in–law of my friend’s mother.' How is the girl related to A's friend?",
    answer: "Cousin",
    options: ["Niece", "Cousin", "Friend", "Daughter"],
    explanations: [
      "Daughter of brother–in–law –-> Niece; Mother’s niece –-> Cousin. So, the girl is the cousin of A's friend.",
    ],
  },
  {
    id: 33,
    question:
      "A and B are young ones of C. If C is the father of A but B is not the son of C. How are B and C related",
    answer: "Daughter and Father",
    options: [
      "Niece and Uncle",
      "Daughter and Father",
      "Niece and Uncle",
      "Daughter and Mother",
    ],
    explanations: [
      "C has two children A and B, if A is his son, B must be his daughter.",
    ],
  },
  {
    id: 34,
    question:
      "F is the brother of A, C is the daughter of A, K is the sister of F and G is the brother of C then who is the uncle of G? ",
    answer: "A",
    options: ["C", "A", "K", "None of the above."],
    explanations: [
      "C & J are children of A and F is the brother of A. So, F is uncle of C & J.",
    ],
  },
  {
    id: 35,
    question:
      "A man pointing to a photograph says. 'The lady in the photograph is my nephew’s maternal grandmother.' How is the lady in the photograph related to the man’s sister who has no other sister?",
    answer: "Mother",
    options: ["Mother–in–law", "Cousin", "Sister–in–law", "Mother"],
    explanations: [
      "The lady is the grandmother of man’s sister’s son i.e., the mother of the mother of man’s sister’s son. i.e., the mother of man’s sister.",
    ],
  },
  {
    id: 36,
    question:
      "If in each number, the first and the second digit are interchanged, which will be the third highest number : 489 , 541 , 654 , 953 , 783",
    answer: "953",
    options: ["489", "541", "783", "953"],
    explanations: [
      "After interchanging first and second digits, the number are 849, 451, 564, 593, 873. Hence, third-highest number = 593 ⇒ 953",
    ],
  },
  {
    id: 37,
    question:
      "Each of A, B, C, and E has a different amount of money. C has more money only than E, B, and A. Who has the maximum amount of money?",
    answer: "D",
    options: ["C", "D", "E", "Data inadequate"],
    explanations: [
      "As per the given information, C has more amount than only E/B/A. So, it means D > C > E / B / A arrangement can be established. So, D has the maximum amount of money.",
    ],
  },
  {
    id: 38,
    question:
      "Roshan is taller than Hardik who is shorter than Sushil. Niza is taller than Harry but shorter than Hardik. Sushil is shorter than Roshan. Who is the tallest?",
    answer: "Roshan",
    options: ["Roshan", "Sushil", "Hardik", "Harry"],
    explanations: [
      "Descending order of the heights is as Roshan > Sushil > Hardik > Niza > Harry. Therefore, the tallest person is Roshan.",
    ],
  },
  {
    id: 39,
    question:
      "Among five boys, Vasant is taller than Manohar but not as tall as Raju. Jayant is taller than Dutta But shorter than Manohar. Who is the tallest in the group?",
    answer: "Raju",
    options: ["Raju", "Manohar", "Vasant", "Cannot be determined"],
    explanations: [
      "Descending order of the heights is as Raju > Vasant > Manohar > Jayant > Dutta. Hence, Raju is the tallest.",
    ],
  },
  {
    id: 40,
    question:
      "Satish read a book on Sunday. Sudha read that book one day prior to Anil but 4 days after Satish. On which day did Anil read the book ?",
    answer: "Friday",
    options: ["Friday", "Thursday", "Tuesday", "Saturday"],
    explanations: [
      "Sudha read the book 4 days after Sunday. it means Sudha read the book on Thursday. Hence, Anil will read the book on Friday.",
    ],
  },
];
